/* eslint-disable */

import { store } from '../../store'
import { http, httpgst } from '../../main'

// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {
  getExpensesAMEX({ commit, dispatch }, payload) {
    let url = 'api/expensesAmex/getExpensesAmexByStatus'
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    let params = {
      startDate: payload.event.context.startDate,
      endDate: payload.event.context.endDate,
      status:
        payload.event.context.status !== null
          ? payload.event.context.status
          : undefined,
      petty_cash: payload.event.petty_cash
        ? payload.event.petty_cash
        : undefined,
      userId: payload.event.userId ? payload.event.userId : undefined,
      type: payload.event.type ? payload.event.type : 'json'
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst
      .get(
        url,
        {
          params,
          responseType: payload.event.type === 'download' ? 'blob' : undefined
        },
        options
      )
      .then(
        response => {
          commit('onGet', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  },
  calculateTotals({ commit, dispatch }, payload) {
    let url = 'api/expensesAmex/calculateTotals'
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    let params = {
      start_date: payload.event.context.startDate,
      end_date: payload.event.context.endDate,
      user_id: payload.event.user_id ? payload.event.user_id : undefined
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst
      .get(
        url,
        {
          params,
          responseType: payload.event.type === 'download' ? 'blob' : undefined
        },
        options
      )
      .then(
        response => {
          commit('onCalculateTotals', {
            event: payload.event,
            response: response
          })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  },
  getExcludedBLUESPEND({ commit }, payload) {
    let url = 'api/expenses_items/excluded'
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    let params = {
      company_id: payload.event.item.company_id,
      start_date: payload.event.item.start_date,
      end_date: payload.event.item.end_date,
      user_id:
        payload.event.item.userId !== null
          ? payload.event.item.userId
          : undefined,
      type: payload.event.item.type ? payload.event.item.type : 'json'
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst
      .get(
        url,
        {
          params,
          responseType:
            payload.event.item.type === 'download' ? 'blob' : undefined
        },
        options
      )
      .then(
        response => {
          commit('onGet', { event: payload.event, response })
        },
        error => {
          commit('onError', { event: payload.event, error })
        }
      )
  },
  getUnreconciledMatches({ commit, dispatch }, payload) {
    let url = 'api/expensesAmex/getUnreconciledMatches'
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    let params = {
      user_id:
        payload.event.user_id !== null ? payload.event.user_id : undefined,
      company_id:
        payload.event.company_id !== null
          ? payload.event.company_id
          : undefined,
      expense_type: payload.event.expense_type,
      start_date: payload.event.startDate,
      end_date: payload.event.endDate,
      filter_by: payload.event.filter_by,
      type: 'json'
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, { params }, options).then(
      response => {
        commit('onGetUnreconciledMatches', {
          event: payload.event,
          response: response
        })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  downloadReport({ commit, dispatch }, payload) {
    let url = 'api/expensesAmex/getUnreconciledMatches'
    let params = {
      user_id:
        payload.event.user_id !== null ? payload.event.user_id : undefined,
      company_id:
        payload.event.company_id !== null
          ? payload.event.company_id
          : undefined,
      expense_type: payload.event.expense_type,
      start_date: payload.event.start_date,
      end_date: payload.event.end_date,
      filter_by: payload.event.filter_by,
      type: 'download'
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, { params: params, responseType: 'blob' }).then(
      response => {
        commit('onDownloadReport', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  matchExcludeItem({ commit, dispatch }, payload) {
    let url =
      'api/expensesAmex/matchExcludeItem/' + payload.event.expense_amex_id
    let params = {
      expense_item_id:
        payload.event.expense_item_id !== null
          ? payload.event.expense_item_id
          : undefined,
      status: payload.event.status !== null ? payload.event.status : undefined
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.put(url, params, {}).then(
      response => {
        commit('onMatchExcludeItem', {
          event: payload.event,
          response: response
        })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  excludeItem({ commit, dispatch }, payload) {
    let url = 'api/expenses_items/' + payload.event.id + '/exclude'
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    let excluded = payload.event.excluded
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.put(url, { excluded }, options).then(
      response => {
        commit('onExcludeItem', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  resetToReconcile({ commit, dispatch }, payload) {
    let url = 'api/expensesAmex/updateStatus'
    let expenses = []
    expenses.push(payload.event.expense_amex_id)
    let params = {
      expense_amex_id: expenses
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.put(url, params, {}).then(
      response => {
        commit('onResetToReconcile', {
          event: payload.event,
          response: response
        })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getExpensesItemAmex({ commit, dispatch }, payload) {
    let url = 'api/expensesAmex/expenses_item_amex'
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    let params = {
      expensesAmexId: payload.event.expense_amex_id,
      expensesItemId:
        payload.event.expense_item_id !== null
          ? payload.event.expense_item_id
          : undefined
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, { params }, options).then(
      response => {
        commit('onGetExpensesItemAmex', {
          event: payload.event,
          response: response
        })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getLogged({ commit, dispatch }, payload) {
    let url = 'api/user-logged'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.defaults.headers.common['X-device'] = 'WEB'
    http.get(url, {}, options).then(
      response => {
        commit('onGetLogged', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  }
}

// mutations
const mutations = {
  onGet(state, payload) {
    if (payload.event.type === 'download') {
      payload.event.context.forceFileDownload(
        payload.response.data,
        `ConciliatedExpenses-${new Date().toISOString().substr(0, 10)}.xlsx`
      )
    } else if (payload.event.item && payload.event.item.type === 'download') {
      payload.event.context.forceFileDownload(
        payload.response.data,
        `ExcludedExpenses-${new Date().toISOString().substr(0, 10)}.xlsx`
      )
    } else {
      if (
        payload.response.data.data.length > 0 &&
        payload.event.context.filterActiveRadio
      ) {
        const userId = payload.event.userId ? payload.event.userId : null
        const arrayData = payload.response.data.data
        let responseMissingAmount = []
        if (
          payload.event.filterActiveRadio === 3 &&
          payload.event.context.activeSecondRequest
        ) {
          responseMissingAmount = payload.response.data.data
        }
        const statusNullFilter = !payload.event.context.activeSecondRequest
          ? arrayData.filter(o => !o.status)
          : responseMissingAmount.filter(o => !o.status)
        switch (payload.event.context.filterActiveRadio) {
          case 1:
            const statusConsiliateFilter = arrayData.filter(
              o =>
                o.status === 'CONSILIATE' &&
                (userId ? userId === o.user_id : !userId)
            )
            payload.event.context.conciliations = statusConsiliateFilter
            payload.event.context.missingAmountData = statusNullFilter
            break
          case 2:
            payload.event.context.conciliations = statusNullFilter
            payload.event.context.missingAmountData = statusNullFilter
            break
          case 3:
            const pettyCashFilter = arrayData.filter(
              o =>
                o.status === 'CONSILIATE' &&
                (userId ? userId === o.user_id : !userId)
            )
            payload.event.context.conciliations = pettyCashFilter
            payload.event.context.missingAmountData = statusNullFilter
            payload.event.context.activeSecondRequest = false
            break
          default:
            payload.event.context.missingAmountData = statusNullFilter
            payload.event.context.conciliations = arrayData
            break
        }
      } else {
        payload.event.context.conciliations = payload.response.data.data
      }
      if (payload.event.status && payload.event.status === 'EXCLUDED') {
        payload.event.context.excludedExpenses = payload.response.data.data
        payload.event.context.getAmountExcluded()
      }
      if (payload.event.status === null) {
        payload.event.context.allExpenses = payload.response.data.data
        payload.event.context.getAmountAll()
      }
      payload.event.context.loading = false
      payload.event.context.loadTable = false
    }
  },
  onCalculateTotals(state, payload) {
    payload.event.context.totalAmounts = payload.response.data.data
    payload.event.context.filterAmounts()
    payload.event.context.loading = false
  },
  onGetUnreconciledMatches(state, payload) {
    payload.event.context.expenses = payload.response.data.data
    payload.event.context.close()
  },
  onDownloadReport(state, payload) {
    payload.event.context.downloadLoading = false
    payload.event.context.forceFileDownload(
      payload.response.data,
      `UnconciledMatches ${new Date().toISOString().substr(0, 10)}.xlsx`
    )
  },
  onMatchExcludeItem(state, payload) {
    payload.event.context.showNotification(
      payload.response.data.data,
      'success'
    )
    payload.event.context.close()
    payload.event.context.refresh()
  },
  onExcludeItem(state, payload) {
    payload.event.context.showNotification(
      payload.response.data.message,
      'success'
    )
    payload.event.context.close()
    payload.event.context.refresh()
  },
  onResetToReconcile(state, payload) {
    payload.event.context.showNotification(
      payload.response.data.message,
      'success'
    )
    payload.event.context.close()
    payload.event.context.refresh()
  },
  onGetExpensesItemAmex(state, payload) {
    payload.event.context.showNotification(
      payload.response.data.message,
      'success'
    )
    payload.event.context.close()
    payload.event.context.refresh()
  },
  onGetLogged(state, payload) {
    let userLogged = payload.response.data.data
    payload.event.context.userLogged = userLogged
  },
  onError(state, payload) {
    payload.event.context.showNotification(payload.error.response, 'error', -1)
    payload.event.context.loadingItems = false
    payload.event.context.close()
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/excluded.js